
export function generateNewId(array){
    var max = array.reduce(function (prev, current) {
        if (+current.id > +prev.id) {
            return current;
        } else {
            return prev;
        }
    });

    let newId = parseInt(max.id) + 1    
    return newId;
}